<template>
<ContenedorCampos :titulo="titulo" :isObligatorio="Obligatorio" :error="error">
  <v-btn-toggle
    v-model="selectValue"
    color="info"
    background-color="backgrey">
    <v-btn 
      :disabled="bDeshabilitado"
      width="100" 
      v-for="(info, key) in aOptions" 
      :key="key"  
      :value="info.ID">
      {{info.DatoMostrar}}
    </v-btn>
  </v-btn-toggle>
</ContenedorCampos>
</template>

<script>
import ContenedorCampos from '@/components/dinamicos/ContenedorCampos.vue'
import DinamicosMixin from '@/mixins/dinamicosMixin.js'
// import ValidarBD from '@/utils/ValidarBD.js'

export default {
  name: 'ToggleButton',
  mixins: [ DinamicosMixin ],
  components: {
    ContenedorCampos,
  },
  data () {
    return {
    }
  },
  async mounted () {
    this.CargarData()

  },
  computed: {
  },

}
</script>

<style lang="scss" scoped>

</style>
